export const customMe = /* GraphQL */ `
  query Me($cognitoUserId: String) {
    me(cognitoUserId: $cognitoUserId) {
      id
      createdAt
      updatedAt
      whatsappNumber
      cognitoUserId
      country
      state
      timeZone
      school {
        id
        createdAt
        promo {
          id
          type
          thumbnailUri
          fileUri
        }

        updatedAt
        classesschool {
          name
          level {
            id
            number
          }
          id
          students {
            id
            age
            user {
              id
              country
            }
                    
            enrollments{
              startDate
              package{
                packageDuration
              }
            }
            name
          }
        }
        nameArabic
        name
      }
      teacher {
        id
        name
        gender
        profilePicture {
          fileUri
          thumbnailUri
        }
        classesschool {
          name
          statistic {
            id
            averageScore
          }
          level {
            id
            number
          }
          id
          students {
            id
            statistic {
              id
              averageScore
            }
            enrollments{
              startDate
              package{
                packageDuration
              }
            }
            name
          }
        }
        school {
          id
          createdAt
          promo {
            id
            type
            thumbnailUri
            fileUri
          }
          
          
          nameArabic
          name
        }
      }
    }
  }
`;
